import { BsModalRef } from 'ngx-bootstrap/modal'
import { Component, Input, OnInit } from '@angular/core'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Dictionary } from '@ngrx/entity'
import { Observable, Subscription, of } from 'rxjs'
import {
  switchMap,
  take,
  map,
  catchError,
  withLatestFrom
} from 'rxjs/operators'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { Booking } from 'src/app/features/booking/booking'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import { BookingService } from 'src/app/features/booking/booking.service'
import { Participation } from 'src/app/features/booking/participation/participation'
import { participationSelectors } from 'src/app/features/booking/participation/participation.selectors'
import { Course } from 'src/app/features/course/course'
import { courseSelectors } from 'src/app/features/course/course.selectors'
import { locationActions } from 'src/app/features/location/location.actions'
import { locationSelectors } from 'src/app/features/location/location.selectors'
import { Member } from 'src/app/features/member/member'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { Organization } from 'src/app/features/organization/organization'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { ProductService } from 'src/app/features/product/product.service'
import { Location } from 'src/app/features/location/location'
import { bookingActions } from 'src/app/features/booking/booking.actions'
import {
  SupervisorBooking,
  SupervisorBookingStatus
} from '../supervisor-booking'
import { supervisorBookingActions } from '../supervisor-booking.actions'
import { NotificationService } from 'src/app/core/notification.service'
import { supervisorBookingSelectors } from '../supervisor-booking.selectors'
import { ParticipationService } from 'src/app/features/booking/participation/participation.service'
import { bookableSlotSelectors } from 'src/app/features/product/bookable-slot/bookable-slot.selectors'
import { BookableSlot } from 'src/app/features/product/bookable-slot/bookable-slot'
import { ICalendarService } from 'src/app/features/booking/icalendar/icalendar.service'
import moment from 'moment-mini'
import { productActions } from 'src/app/features/product/product.actions'
import { Actions, ofType } from '@ngrx/effects'
import { employeeBookingActions } from '../../employee-booking/employee-booking.actions'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'
import {
  EmployeeBookingColourCodes,
  EmployeeBookingTypes
} from '../../employee-booking/employee-booking'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { employeeBookingSelectors } from '../../employee-booking/employee-booking.selectors'
import { sleep } from 'src/app/shared/utils/sleep'
import { employeeContractSelectors } from '../../employee-contract/employee-contract.selectors'
import { employeeContractManagerLinkSelectors } from '../../employee-contract-manager-link/employee-contract-manager-link.selectors'
import { EmployeeBookingService } from '../../employee-booking/employee-booking.service'
import { TranslateService } from '@ngx-translate/core'
import { participationActions } from 'src/app/features/booking/participation/participation.actions'
import { Router } from '@angular/router'
import { AppRoutesNS } from 'src/app/app-routes.namespace'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SupervisorBookingDetailsModalComponent implements OnInit {
  @Input() supervisorBookingId: number
  @Input() bookingId: number
  public organization: Organization
  public productId: number
  public courseId: number

  public product$: Observable<Product>
  public linkedProduct$: Observable<Product>
  public booking$: Observable<Booking>
  public supervisorBooking$: Observable<SupervisorBooking>

  public SupervisorBookingStatus = SupervisorBookingStatus
  public subscriptions$: Subscription[] = []
  public bookings$: Observable<Booking[]>
  public productEntities$: Observable<Dictionary<Product>>
  public courseEntities$: Observable<Dictionary<Course>>
  public locationEntities$: Observable<Dictionary<Location>>
  public memberEntities$: Observable<Dictionary<Member>>
  public participants$: Observable<Participation[]>
  public selectedLanguage$: Observable<string>
  public member$: Observable<Member>
  public bookingEntities$: Observable<Dictionary<Booking>>
  public allBookableSlots$: Observable<BookableSlot[]>
  public form: UntypedFormGroup
  public currentBooking$: Observable<Booking>
  public supervisorModuleConfig = environment.moduleConfigs.supervisorModule
  private employeeBookingColourCodes = EmployeeBookingColourCodes

  constructor(
    private employeeBookingService: EmployeeBookingService,
    private actions$: Actions,
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    private icalendarService: ICalendarService,
    public productService: ProductService,
    public bookingService: BookingService,
    private notificationService: NotificationService,
    public participationService: ParticipationService,
    public fb: UntypedFormBuilder,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.form = this.fb.group({
      totalMembersOnline: [null, [Validators.min(0)]]
    })

    this.store.dispatch(
      bookingActions.fetchOneById({
        id: this.bookingId,
        params: RequestQueryBuilder.create({
          join: [
            { field: 'product' },
            { field: 'linkedProduct' },
            { field: 'product.translations' },
            { field: 'linkedProduct.translations' }
            //{ field: 'participations' },
            // { field: 'participations.member' },
            // { field: 'participations.organization' }
          ]
        })
      })
    )
    this.store.dispatch(
      participationActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            bookingId: this.bookingId
          },

          join: [{ field: 'member' }, { field: 'organization' }]
        })
      })
    )
    this.store.dispatch(
      supervisorBookingActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            bookingId: this.bookingId,
            status: SupervisorBookingStatus.ACCEPTED
          }
        })
      })
    )

    this.store.dispatch(locationActions.fetchMany({}))

    this.member$ = this.store.select(authSelectors.selectMember)

    this.supervisorBooking$ = this.store.select(
      supervisorBookingSelectors.selectById,
      this.supervisorBookingId
    )

    this.booking$ = this.store.select(
      bookingSelectors.selectById,
      this.bookingId
    )

    this.linkedProduct$ = this.booking$.pipe(
      switchMap((booking) =>
        this.store.select(productSelectors.selectById, booking.linkedProductId)
      )
    )

    this.product$ = this.booking$.pipe(
      switchMap((booking) =>
        this.store.select(productSelectors.selectById, booking.productId)
      )
    )

    this.participants$ = this.booking$.pipe(
      switchMap((booking) =>
        this.store.select(participationSelectors.selectByFilter, {
          field: 'bookingId',
          value: booking.id
        })
      )
    )

    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.courseEntities$ = this.store.select(courseSelectors.selectEntities)
    this.locationEntities$ = this.store.select(locationSelectors.selectEntities)
    this.memberEntities$ = this.store.select(memberSelectors.selectEntities)
    this.bookingEntities$ = this.store.select(bookingSelectors.selectEntities)

    this.allBookableSlots$ = this.store.select(bookableSlotSelectors.selectAll)

    this.currentBooking$ = this.bookingEntities$.pipe(
      map((bookingEntities) => bookingEntities[this.bookingId])
    )
    this.actions$
      .pipe(ofType(bookingActions.updateOneById))
      .subscribe((actions) => {
        if (actions) {
          this.notificationService.emit('alerts.success', 'success')
        }
      })
  }

  public cancel() {
    this.bsModalRef.hide()
  }

  public onClickAccept() {
    this.supervisorBooking$.pipe(take(1)).subscribe((supervisorBooking) => {
      this.store.dispatch(
        supervisorBookingActions.updateOneById({
          id: supervisorBooking.id,
          params: { status: SupervisorBookingStatus.ACCEPTED }
        })
      )

      this.notificationService.emit('alerts.success', 'success')
    })
  }
  public onClickDecline(setAsUnavailable: boolean) {
    this.supervisorBooking$
      .pipe(
        take(1),
        withLatestFrom(
          this.store.select(employeeContractSelectors.selectEntities),
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole),
          this.store.select(bookingSelectors.selectEntities),
          this.store.select(employeeBookingSelectors.selectAll),
          this.member$,
          this.translate.get('myWorkModule.declineSupervisorConfirm')
        )
      )
      .subscribe(
        ([
          supervisorBooking,
          contractEntities,
          userRole,
          bookingEntities,
          allEmployeeBookings,
          member,
          confirmMsg
        ]: any) => {
          if (supervisorBooking.status == SupervisorBookingStatus.ACCEPTED) {
            if (!window.confirm(`${confirmMsg}`)) {
              return
            }

            this.contiueonClickDecline(
              setAsUnavailable,
              supervisorBooking,
              contractEntities,
              userRole,
              bookingEntities,
              allEmployeeBookings,
              member
            )
          } else {
            this.contiueonClickDecline(
              setAsUnavailable,
              supervisorBooking,
              contractEntities,
              userRole,
              bookingEntities,
              allEmployeeBookings,
              member
            )
          }
        }
      )
  }

  public goToSurveys() {
    this.cancel()
    this.router.navigateByUrl(
      AppRoutesNS.Booking.SUPERVISOR_BOOKING_OVERVIEW_SURVEYS.replace(
        ':bookingId',
        this.bookingId.toString()
      )
    )
  }

  private contiueonClickDecline(
    setAsUnavailable,
    supervisorBooking,
    contractEntities,
    userRole,
    bookingEntities,
    allEmployeeBookings,
    member
  ) {
    const similarEmployeeBookings = allEmployeeBookings.filter(
      (employeeBooking) =>
        moment(employeeBooking.startDate).format('YYYY-MM-DD HH:mm') ===
          moment(bookingEntities[supervisorBooking.bookingId].startDate).format(
            'YYYY-MM-DD HH:mm'
          ) &&
        moment(employeeBooking.endDate).format('YYYY-MM-DD HH:mm') ===
          moment(bookingEntities[supervisorBooking.bookingId].endDate)
            .add(1, 'minute')
            .format('YYYY-MM-DD HH:mm') &&
        employeeBooking.productId ===
          bookingEntities[supervisorBooking.bookingId].linkedProductId &&
        employeeBooking.personId === supervisorBooking.personId
    )
    if (similarEmployeeBookings && similarEmployeeBookings.length > 0) {
      for (const emmployeeBooking of similarEmployeeBookings) {
        this.subscriptions$.push(
          this.member$
            .pipe(
              take(1),
              withLatestFrom(
                this.store.select(
                  employeeContractSelectors.selectById,
                  emmployeeBooking?.contractId
                ),
                this.store.select(
                  employeeContractManagerLinkSelectors.selectEntities
                )
              )
            )
            .subscribe(
              ([
                member,
                employeeContract,
                employeeContractManagerLinkEntities
              ]) => {
                let bookingIsAlreadyChecked = false
                let firstSupervisorCheck = null
                employeeContract?.employeeContractManagerLinks?.forEach(
                  (employeeContractManagerLinkId) => {
                    if (
                      moment(
                        employeeContractManagerLinkEntities[
                          employeeContractManagerLinkId
                        ]?.checkedTillDate
                      ).isBefore(moment(firstSupervisorCheck)) ||
                      !firstSupervisorCheck
                    ) {
                      firstSupervisorCheck =
                        employeeContractManagerLinkEntities[
                          employeeContractManagerLinkId
                        ]?.checkedTillDate
                    }
                  }
                )
                if (
                  firstSupervisorCheck &&
                  moment(firstSupervisorCheck).isAfter(
                    moment(emmployeeBooking.endDate)
                  )
                ) {
                  bookingIsAlreadyChecked = true
                }
                if (emmployeeBooking?.id && !bookingIsAlreadyChecked) {
                  bookingIsAlreadyChecked =
                    !this.employeeBookingService.showCancelButton(
                      emmployeeBooking,
                      contractEntities,
                      employeeContractManagerLinkEntities
                    )
                }
                if (!bookingIsAlreadyChecked) {
                  this.actions$
                    .pipe(
                      ofType(
                        supervisorBookingActions.upsertMany,
                        supervisorBookingActions.upsertOne
                      ),

                      take(1),
                      //timeout(1000),

                      catchError(() => {
                        return of(null)
                      })
                    )
                    .subscribe((action) => {
                      if (!action) {
                        console.warn(`Backend denied supervisorBooking update`)
                        return false
                      }
                      console.log(
                        `Delete employeeBooking with id ${emmployeeBooking.id} and startDate:${emmployeeBooking.startDate} and endDate:${emmployeeBooking.endDate}`
                      )

                      this.store.dispatch(
                        employeeBookingActions.removeOne({
                          id: emmployeeBooking.id
                        })
                      )
                    })
                  this.continueDecline(
                    supervisorBooking,
                    setAsUnavailable,
                    userRole,
                    bookingEntities,
                    member
                  )
                } else {
                  this.notificationService.emit(
                    'employeeModule.bookingAlreadyChecked',
                    'error'
                  )
                }
              }
            )
        )
      }
    } else {
      this.continueDecline(
        supervisorBooking,
        setAsUnavailable,
        userRole,
        bookingEntities,
        member
      )
    }
  }
  private async continueDecline(
    supervisorBooking,
    setAsUnavailable,
    userRole,
    bookingEntities,
    member
  ) {
    this.subscriptions$.push(
      this.member$.pipe(take(1)).subscribe((member) => {
        ;(this.store.dispatch(
          supervisorBookingActions.updateOneById({
            id: supervisorBooking.id,
            params: { status: SupervisorBookingStatus.DECLINED }
          })
        ),
          this.actions$
            .pipe(
              ofType(
                supervisorBookingActions.upsertMany,
                supervisorBookingActions.upsertOne
              ),
              take(1),

              catchError(() => of(null))
            )
            .subscribe((action) => {
              if (setAsUnavailable) {
                sleep(1 * 1500).then(() => {
                  const siteId =
                    userRole && userRole.siteId
                      ? userRole.siteId
                      : environment.defaultSiteId

                  this.store.dispatch(
                    employeeBookingActions.createOne({
                      entity: {
                        siteId: siteId,
                        productId: null,
                        startDate: moment(
                          bookingEntities[supervisorBooking?.bookingId]
                            ?.startDate
                        ),
                        endDate: moment(
                          bookingEntities[supervisorBooking?.bookingId]?.endDate
                        ).add(1, 'minute'),
                        // moment(
                        //   bookingEntities[supervisorBooking?.bookingId]?.endDate
                        // ).minutes() != 59
                        //   ? moment(
                        //       bookingEntities[supervisorBooking?.bookingId]?.endDate
                        //     ).subtract(1, 'minute')
                        //   : moment(
                        //       bookingEntities[supervisorBooking?.bookingId]?.endDate
                        //     ),
                        contractId: null,
                        type: EmployeeBookingTypes.UNAVAILABLE,
                        personId: member.id,
                        colour: this.employeeBookingColourCodes.BY_WEBSITE
                      }
                    })
                  )
                })
              }
              this.notificationService.emit('alerts.success', 'success')
              sleep(1 * 1000).then(() => {
                this.cancel()
              })
            }))
      })
    )
  }
  public getIcalDownload() {
    this.booking$.pipe(take(1)).subscribe((booking) => {
      this.productEntities$.pipe(take(1)).subscribe((productEntities) => {
        let arrayIds = []
        if (booking.linkedProductId) {
          arrayIds = [...arrayIds, booking.linkedProductId]
        }
        if (booking.productId) {
          arrayIds = [...arrayIds, booking.productId]
        }
        if (arrayIds.length > 0) {
          this.store.dispatch(
            productActions.fetchMany({
              params: RequestQueryBuilder.create({
                search: {
                  id: {
                    [CondOperator.IN]: arrayIds
                  }
                },
                join: [{ field: 'translations' }]
              })
            })
          )
          this.actions$
            .pipe(
              ofType(productActions.upsertMany),
              take(1),

              catchError(() => of(null))
            )
            .subscribe((action) => {
              this.icalendarService.getIcaldownloadForProduct(
                productEntities[booking.linkedProductId],
                productEntities[booking.productId],
                moment(booking.startDate),
                moment(booking.endDate)
              )
            })
        } else {
          this.icalendarService.getIcaldownloadForProduct(
            productEntities[booking.linkedProductId],
            productEntities[booking.productId],
            moment(booking.startDate),
            moment(booking.endDate)
          )
        }
      })
    })
  }
  public getNumberOfSupervisors$(): Observable<number> {
    return this.store
      .select(supervisorBookingSelectors.selectByFilter, {
        field: 'bookingId',
        value: this.bookingId
      })
      .pipe(
        take(1),
        map((supervisorBookings) => {
          return supervisorBookings.filter(
            (supervisorBooking) =>
              supervisorBooking.status == SupervisorBookingStatus.ACCEPTED
          ).length
        })
      )
  }

  public onSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      this.notificationService.emit('alerts.error', 'error')
      return
    }
    this.booking$.pipe(take(1)).subscribe((booking) => {
      this.store.dispatch(
        bookingActions.updateOneById({
          id: this.bookingId,
          params: {
            ...this.form.value,
            endDate: moment(booking.endDate),
            startDate: moment(booking.startDate),
            startEventDate: moment(booking.startEventDate),
            expiredDate: moment(booking.expiredDate)
          }
        })
      )
    })
  }
}
